module.exports = __webpack_public_path__ + "static/img/coupon_list@2x.45347531.png";